import { GetUnderwriters, GetUnderwritersVariables } from "_graphql/queries/__generated__/GetUnderwriters";

import { getUnderwriters } from "_graphql/place-it/queries/underwriters.place-it";
import { placeItClient } from "_graphql";
import { useQuery } from "@apollo/client";

export const useUnderWriters = (variables: GetUnderwritersVariables) => {
    const { data, ...rest } = useQuery<GetUnderwriters, GetUnderwritersVariables>(getUnderwriters, {
        variables,
        client: placeItClient,
        fetchPolicy: "network-only",
    });

    return { underwriters: data?.underwriters?.data || [], length: data?.underwriters?.paginatorInfo?.total || 0, ...rest };
}